import { create } from 'zustand';

export const useDemoStore = create((set) => ({
  leads: [
    { _id: '1', customId: 'L-001', name: 'Ramesh Traders', phone: '+91 9876543210', customerType: 'Dealer', leadSource: 'Walk-in', status: 'new', interestedIn: 'uPVC windows' }
  ],
  estimations: [
    { _id: '1', customId: 'EST-1001', leadId: '1', customer: 'Ramesh Traders', product: 'uPVC casement window', amount: '₹17,100', status: 'Pending', date: '22 Jul 2026' }
  ],
  orders: [
    { _id: '1', customId: 'SO-1039', leadId: '1', customer: 'Ramesh Traders', amount: '₹17,100', status: 'Pending', date: '22 Jul 2026', items: [{ item: 'uPVC casement window', qty: 3, rate: 285 }] }
  ],
  payments: [
    { _id: '1', customId: 'PAY-001', orderId: '1', customer: 'Ramesh Traders', amount: '₹5,000', date: '22 Jul 2026', method: 'Cash' }
  ],
  companyLogo: null,
  setCompanyLogo: (logo) => set({ companyLogo: logo }),

  addLead: (lead) => {
    const now = new Date();
    const year = now.getFullYear();
    const day = String(now.getDate()).padStart(2, '0');
    const seq = String(Math.floor(Math.random() * 90000) + 10000);
    const sd_id = `SD-${year}-${day}-${seq}`;
    
    const newLead = { 
      _id: Date.now().toString(), 
      customId: `L-10${Math.floor(Math.random() * 100)}`, 
      sd_id,
      next_stage: "",
      ...lead 
    };
    set((state) => ({ leads: [newLead, ...state.leads] }));
    return newLead;
  },
  updateLead: (id, updates) => set((state) => {
    const finalUpdates = { ...updates };
    if (updates.next_stage) {
      finalUpdates.status = updates.next_stage;
    }
    return {
      leads: state.leads.map(l => l._id === id ? { ...l, ...finalUpdates } : l)
    };
  }),

  addEstimation: (est) => set((state) => ({ estimations: [{ _id: Date.now().toString(), customId: `EST-${state.estimations.length + 1001}`, ...est }, ...state.estimations] })),
  updateEstimation: (id, updates) => set((state) => {
    const estimations = state.estimations.map(e => e._id === id ? { ...e, ...updates } : e);
    // If approved, automatically create an order
    const updatedEst = estimations.find(e => e._id === id);
    if (updates.status === 'Client Approved' && updatedEst) {
      const newOrder = {
        _id: Date.now().toString(),
        customId: `SO-${state.orders.length + 1040}`,
        leadId: updatedEst.leadId,
        customer: updatedEst.customer,
        amount: updatedEst.amount,
        status: 'Pending', // initial status
        date: new Date().toLocaleDateString('en-GB'),
        items: updatedEst.items || []
      };
      return { estimations, orders: [newOrder, ...state.orders] };
    }
    return { estimations };
  }),

  addOrder: (order) => set((state) => ({ orders: [{ _id: Date.now().toString(), customId: `SO-${state.orders.length + 1040}`, ...order }, ...state.orders] })),
  updateOrder: (id, updates) => set((state) => ({
    orders: state.orders.map(o => o._id === id ? { ...o, ...updates } : o)
  })),

  addPayment: (payment) => set((state) => ({ payments: [{ _id: Date.now().toString(), customId: `PAY-${state.payments.length + 1}`, date: new Date().toLocaleDateString('en-GB'), ...payment }, ...state.payments] })),
}));




